import { useQuery } from "react-query";
import { parseToStudentCardsProgramFrontEndModel } from "../helpers/parseToStudentCardsProgramFrontEndModel";
import { useApplicationQueries } from "../hooks/useApplicationQueries";
import { orderApplicationsByStatus } from "../helpers/orderStudentApplications";
import { EducationType } from "../../school/constants/types";
import { parseToStudentCardsLanguageCourseFrontEndModel } from "../helpers/parseToStudentCardsLanguageCourseFrontEndModel";

type TUseStudentApplications = (studentId: string) => {
  isLoading: boolean;
  applications: any[];
};

export const useStudentApplications: TUseStudentApplications = (studentId) => {
  const { fetchStudentApplications } = useApplicationQueries();

  const {
    isLoading: isLoadingHigher,
    data: { data: applicationsHigher = [] } = {},
  } = useQuery<any>(`${"studentApplicationsHigher" + studentId}`, () =>
    fetchStudentApplications({ studentId }, EducationType.Higher).then(
      (response) => parseToStudentCardsProgramFrontEndModel(response),
    ),
  );

  const {
    isLoading: isLoadingSecondary,
    data: { data: applicationsSecondary = [] } = {},
  } = useQuery<any>(`${"studentApplicationsSecondary" + studentId}`, () =>
    fetchStudentApplications({ studentId }, EducationType.Secondary).then(
      (response) => parseToStudentCardsProgramFrontEndModel(response),
    ),
  );

  const {
    isLoading: isLoadingLanguageCourse,
    data: { data: applicationsLanguageCourse = [] } = {},
  } = useQuery<any>(`${"studentApplicationsLanguageCourse" + studentId}`, () =>
    fetchStudentApplications({ studentId }, EducationType.Language).then(
      (response) => parseToStudentCardsLanguageCourseFrontEndModel(response),
    ),
  );

  return {
    isLoading: isLoadingHigher || isLoadingSecondary || isLoadingLanguageCourse,
    applications: orderApplicationsByStatus([
      ...applicationsHigher,
      ...applicationsSecondary,
      ...applicationsLanguageCourse,
    ]),
  };
};
